export interface Image {
  id: number;
  type: number;
  name: string;
  account_id: number;
  user_id: number;
  created_at: string;
  updated_at: string;
  link: string;
  created_by: string;
}

export enum ChecklistStatusEnum {
  Open = 'open',
  Closed = 'closed'
}
